import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class AdminGuideIcon extends BaseIcon {
    getChildren = () => {
        return [
            <g transform="translate(-1704.5 -188)">
                <g transform="translate(1583.5 187.999)">
                    <path d="M135.5,28a.491.491,0,0,1-.177-.033.5.5,0,0,1-.3-.333c-2.248-4.261-13.4-4.1-13.509-4.1a.487.487,0,0,1-.359-.143.5.5,0,0,1-.15-.357V4.5a1.054,1.054,0,0,1,.321-.751,1,1,0,0,1,.752-.3c7.224.093,11.52,2.271,13.075,3.237C136.7,1.21,142.343.021,142.4.01a.51.51,0,0,1,.415.1A.5.5,0,0,1,143,.5V4h4.9A1.086,1.086,0,0,1,149,5.072V23.946a1.1,1.1,0,0,1-1.087,1.089c-9.526.118-12.013,2.768-12.037,2.8A.507.507,0,0,1,135.5,28ZM143,5V19.2a.5.5,0,0,1-.435.5c-3.08.4-5.5,3.553-6.327,6.639,1.545-.9,4.938-2.217,11.663-2.3a.1.1,0,0,0,.1-.1V5.081A.091.091,0,0,0,147.908,5H143ZM121.942,22.562c2.1.014,9.847.286,13.058,3.456V7.753c-.932-.633-5.253-3.252-13-3.352ZM135.99,7.432a.46.46,0,0,1,.01.1V24.125c1.213-2.557,3.371-4.806,6-5.348V1.151A8.636,8.636,0,0,0,135.99,7.432Z" fill="#e8f1ff"/>
                </g>
            </g>
        ]
    }
    getViewBox = () => '0 0 28 27.997'
}
